import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
    {
        path: '/login',
        name: 'login',
        meta: {
            title: '登录'
        },
        component: () => import('../views/Login.vue')
    },
    {
        path: '/',
        name: 'home',
        component: () => import('../views/Home.vue'),
        // redirect: '/index',
        children: [
            {
                path: '/index',
                name: 'index',
                meta: {
                    title: '系统首页'
                },
                component: () => import('../views/auth-entity/ppid-management/PPIDInfoList.vue')
            },
            // {
            //     path: "/tabs",
            //     name: "tabs",
            //     meta: {
            //         title: 'tab标签'
            //     },
            //     component: () => import ( /* webpackChunkName: "tabs" */ "../views/Tabs.vue")
            // },
            {
                path: '/ppid-info',
                name: 'PPID信息管理',
                meta: {
                    title: 'PPID信息管理'
                },
                component: () => import('../views/auth-entity/ppid-management/PPIDInfoList.vue')
            },
            {
                path: '/bulk/vended/auth-entities',
                name: '批量销售记录管理',
                meta: {
                    title: '批量销售记录管理'
                },
                component: () => import('../views/auth-entity/BulkVendedTokens.vue')
            },
            {
                path: '/bulk/auth-entity/records',
                name: '批量销售记录管理',
                meta: {
                    title: '批量销售记录管理'
                },
                component: () => import('../views/auth-entity/bulk-vended/BulkVendedList.vue')
            },
            {
                path: '/auth-entities/file-list',
                name: '批量销售文件管理',
                meta: {
                    title: '批量销售文件管理'
                },
                component: () => import('../views/auth-entity/BulkVendedAuthEntityFileList.vue')
            },
            {
                path: '/auth-entities-list',
                name: 'Token信息管理',
                meta: {
                    title: 'Token信息管理'
                },
                component: () => import('../views/auth-entity/auth-entities/AuthEntitiesList.vue')
            },
            {
                path: '/bulk-vended-times',
                name: '批量销售次数管理',
                meta: {
                    title: '批量销售次数管理'
                },
                component: () => import('../views/auth-entity/BulkVendedTimesRecords.vue')
            },
            {
                path: '/auth-entity/event-list',
                name: '操作事件记录管理',
                meta: {
                    title: '操作事件记录管理'
                },
                component: () => import('../views/auth-entity/handle-event/HandleEventList.vue')
            },
            {
                path: '/auth-entity/bulk-register-records',
                name: '事件结果记录管理',
                meta: {
                    title: '事件结果记录管理'
                },
                component: () => import('../views/auth-entity/BulkRegisterRecords.vue')
            },
            // 以下是账号相关
            {
                path: '/account/list',
                name: '账号列表',
                meta: {
                    title: '账号列表'
                },
                component: () => import('../views/user/AccountHandle.vue')
            }
        ]
    }
]

const router =createRouter({
    history: createWebHashHistory(),
    routes
})
// const accountStore = useAccountStore(pinia)

// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
    // 修改页面title
    if (to.meta.title) {
        document.title = `${import.meta.env.VITE_APP_TITLE} - ` + to.meta.title
    }
    // 执行登录页面
    if (to.path === '/login') {
        return next()
    }

    // 获取token
    const token = sessionStorage.getItem('token')
    // const token = accountStore.getToken
    if (!token) {
        return next('/login')
    }

    return next()
})

export default router
